import axios from 'axios';

import { env } from '@/config/env';
import { getOrCreateDeviceId } from '@/utils/deviceId';
import { parseLoginEnvelope } from '@/utils/parseAuthEnvelope';

import type { LoginResponse } from '../types/auth.types';

import { mapApiUserToUser, mapMeProfileToUser } from './mapApiUser';

/**
 * Thử khôi phục phiên từ cookie refresh HttpOnly (không cần access token).
 * Trả về payload login để `dispatch(setCredentials(...))` nếu thành công.
 */
export async function trySilentSessionRestore(): Promise<LoginResponse | null> {
  if (!env.API_BASE_URL) return null;
  try {
    const { data } = await axios.post(`${env.API_BASE_URL}/api/auth/refresh`, undefined, {
      withCredentials: true,
      headers: { 'X-Device-Id': getOrCreateDeviceId() },
    });
    const parsed = parseLoginEnvelope(data);
    if (!parsed) return null;
    const { access_token, user: userRaw, device_id } = parsed;

    const userFromMe = mapMeProfileToUser(userRaw);
    const user =
      userFromMe ??
      mapApiUserToUser({
        id: String(userRaw.id),
        username: String(userRaw.username),
        role: typeof userRaw.role === 'string' ? userRaw.role : undefined,
        role_slug: typeof userRaw.role_slug === 'string' ? userRaw.role_slug : undefined,
      });

    return {
      accessToken: access_token,
      user,
      refreshToken: null,
      deviceId: device_id,
    };
  } catch {
    return null;
  }
}
